var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "answerCompare" }, [
    _c("div", { staticClass: "header" }, [
      _c("span", [_vm._v("当前课程id： " + _vm._s(_vm.params.courseId))]),
      _vm._v(" "),
      _c("span", [_vm._v("当前班级id： " + _vm._s(_vm.params.classId))]),
      _vm._v(" "),
      _c("span", [_vm._v("当前用户ID： " + _vm._s(_vm.params.userId))]),
      _vm._v(" "),
      _c("span", [_vm._v("试题id： " + _vm._s(_vm.params.questionId))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "main" }, [
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "left" }, [
          _c("h3", [_vm._v("老师的标准答案：")]),
          _vm._v(" "),
          _c(
            "ul",
            _vm._l(_vm.teacherAnswer, function(item, index) {
              return _c("li", { key: index }, [
                _c("h3", [
                  _vm._v(
                    " 步骤 " +
                      _vm._s(index + 1) +
                      "： " +
                      _vm._s(item.eventName) +
                      " （" +
                      _vm._s(item.formName) +
                      "）"
                  )
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  [
                    _vm._v("\n              唯一标识字段："),
                    _c("br"),
                    _vm._v(" "),
                    item.formMapper
                      ? _c("json-viewer", {
                          attrs: {
                            value: item.formMapper,
                            "expand-depth": 1,
                            boxed: "",
                            sort: ""
                          }
                        })
                      : _c("json-viewer", {
                          attrs: {
                            value: "无",
                            "expand-depth": 1,
                            boxed: "",
                            sort: ""
                          }
                        })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "p",
                  { staticStyle: { color: "cyan" } },
                  [
                    _vm._v("\n              标准答案内容："),
                    _c("br"),
                    _vm._v(" "),
                    _c("json-viewer", {
                      attrs: {
                        value: item.value,
                        "expand-depth": 1,
                        boxed: "",
                        sort: ""
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "p",
                  [
                    _vm._v("\n              协议： "),
                    _c("br"),
                    _vm._v(" "),
                    item.aggrementMapper
                      ? _c("json-viewer", {
                          attrs: {
                            value: item.aggrementMapper,
                            "expand-depth": 1,
                            boxed: "",
                            sort: ""
                          }
                        })
                      : _c("json-viewer", {
                          attrs: {
                            value: "无",
                            "expand-depth": 1,
                            boxed: "",
                            sort: ""
                          }
                        })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "p",
                  [
                    _vm._v("\n              权重："),
                    _c("br"),
                    _vm._v(" "),
                    item.weightMapper
                      ? _c("json-viewer", {
                          attrs: {
                            value: item.weightMapper,
                            "expand-depth": 1,
                            boxed: "",
                            sort: ""
                          }
                        })
                      : _c("json-viewer", {
                          attrs: {
                            value: "无",
                            "expand-depth": 1,
                            boxed: "",
                            sort: ""
                          }
                        })
                  ],
                  1
                )
              ])
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "right" }, [
          _c("h3", [_vm._v("学生作答的有效内容：")]),
          _vm._v(" "),
          _c(
            "ul",
            _vm._l(_vm.studentAnswer, function(item, index) {
              return _c("li", { key: index }, [
                _c("h3", [
                  _vm._v(
                    "步骤 " +
                      _vm._s(index + 1) +
                      "： " +
                      _vm._s(item.form_name) +
                      "\n              "
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "fuzhianniu",
                      on: {
                        click: function($event) {
                          return _vm.copyStudentContent(item)
                        }
                      }
                    },
                    [_vm._v("复制埋点")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  [
                    _vm._v("\n              唯一标识字段："),
                    _c("br"),
                    _vm._v(" "),
                    _c("json-viewer", {
                      attrs: {
                        value: item.form_mapper,
                        "expand-depth": 1,
                        boxed: "",
                        sort: ""
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "p",
                  { staticStyle: { color: "cyan" } },
                  [
                    _vm._v("\n              学生作答内容： "),
                    _c("br"),
                    _vm._v(" "),
                    _c("json-viewer", {
                      attrs: {
                        value: item.detail_content,
                        "expand-depth": 1,
                        boxed: "",
                        sort: ""
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "当前用户操作行为： " +
                      _vm._s(item.signStatus == 0 ? "正常" : "删除")
                  )
                ]),
                _vm._v(" "),
                _c("p", [_vm._v("操作时间： " + _vm._s(item.create_date))])
              ])
            }),
            0
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3282101d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3282101d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/answerCompare.vue
// module id = null
// module chunks = 